import React, { useEffect, useState } from 'react';
import { Box, Checkbox, FormControlLabel, Link, Stack, Typography } from '@mui/material';
import TopAppBar from '../layout/TopAppBar';
import { PageContainer, SectionHeader, SurfaceCard } from '../ui/ConvivialComponents';
import { LEGAL_DOCUMENTS, getLegalConsents, updateNewsletterMarketingConsent } from '../../services/firebaseData';
import { useAuth } from '../../context/AuthContext';
import AnalyticsConsent from '../AnalyticsConsent';

export default function PrivacyPreferencesPage() {
  const { userId } = useAuth();
  const [newsletter, setNewsletter] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  useEffect(() => {
    let active = true;
    getLegalConsents(userId).then((legal) => {
      if (active) {
        setNewsletter(Boolean(legal?.newsletterMarketingConsent));
        setLoading(false);
      }
    }).catch((error) => {
      console.error('Unable to load privacy preferences:', error);
      if (active) setLoading(false);
    });
    return () => { active = false; };
  }, [userId]);

  const handleNewsletterChange = async (event) => {
    const checked = event.target.checked;
    setNewsletter(checked);
    setMessage('');
    try {
      await updateNewsletterMarketingConsent(userId, checked);
      setMessage('Preferenza aggiornata.');
    } catch (error) {
      console.error('Unable to update newsletter preference:', error);
      setNewsletter(!checked);
      setMessage('Non siamo riusciti ad aggiornare la preferenza.');
    }
  };

  return (
    <>
      <TopAppBar title="ConvivialApp.it" variant="back" />
      <PageContainer maxWidth="760px" sx={{ pt: 'calc(var(--cv-top-bar-height) + 32px)' }}>
        <Stack spacing={3}>
          <SurfaceCard><AnalyticsConsent /></SurfaceCard>
          <Box>
            <Typography variant="h1" sx={{ color: 'primary.main', fontSize: { xs: 28, md: 34 } }}>Privacy e comunicazioni</Typography>
            <Typography color="text.secondary">Gestisci le preferenze relative alle comunicazioni di Convivial.</Typography>
          </Box>
          <SurfaceCard>
            <SectionHeader title="Documenti accettati" />
            <Typography variant="body2" color="text.secondary">Hai accettato i <Link href={LEGAL_DOCUMENTS.termsUrl} target="_blank" rel="noreferrer">Termini e condizioni</Link> e hai preso visione della <Link href={LEGAL_DOCUMENTS.privacyUrl} target="_blank" rel="noreferrer">Privacy Policy</Link>. La <Link href={LEGAL_DOCUMENTS.cookieUrl} target="_blank" rel="noreferrer">Cookie Policy</Link> è disponibile qui.</Typography>
          </SurfaceCard>
          <SurfaceCard>
            <SectionHeader title="Newsletter e marketing" />
            <FormControlLabel
              control={<Checkbox checked={newsletter} onChange={handleNewsletterChange} disabled={loading} />}
              label="Desidero ricevere newsletter e comunicazioni di marketing da Convivial."
              sx={{ alignItems: 'flex-start', m: 0 }}
            />
            {message && <Typography variant="body2" color={message.startsWith('Non') ? 'error' : 'success.main'} sx={{ mt: 1 }}>{message}</Typography>}
          </SurfaceCard>
        </Stack>
      </PageContainer>
    </>
  );
}
